/**
 * Sort Master Data submenu entries alphabetically by display title.
 */
export function sortMasterDataSubmenu<T extends { title?: string; displayName?: string }>(
  parentTitle: string | undefined,
  items: T[] | undefined | null
): T[] {
  if (!items?.length) {
    return items || [];
  }

  const parent = (parentTitle || '').trim().toLowerCase();
  if (parent !== 'master data' && parent !== 'masterdata') {
    return items;
  }

  return [...items].sort((a, b) => {
    const aTitle = (a.displayName || a.title || '').trim();
    const bTitle = (b.displayName || b.title || '').trim();
    return aTitle.localeCompare(bTitle, undefined, { sensitivity: 'base' });
  });
}

export function ensureFitterflyAdditivesMenuItem<T extends Record<string, any>>(items: T[] | undefined | null): T[] {
  const list = Array.isArray(items) ? [...items] : [];
  const exists = list.some((item) => {
    const path = String(item?.path || item?.url || '').toLowerCase();
    const title = String(item?.title || item?.displayName || item?.name || '').toLowerCase();
    return path.includes('fitterfly-additive') || title.includes('fitterfly additive');
  });
  if (!exists) {
    list.push({
      path: '/master/fitterfly-additives',
      title: 'Fitterfly Additives',
      name: 'Fitterfly Additives',
      displayName: 'Fitterfly Additives',
      icon: 'ft-arrow-right submenu-icon',
      class: '',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: []
    } as unknown as T);
  }
  return list;
}

/** Ensure Product Type appears under Master Data even if NavTree row is missing. */
export function ensureProductTypeMenuItem<T extends Record<string, any>>(items: T[] | undefined | null): T[] {
  const list = Array.isArray(items) ? [...items] : [];
  const exists = list.some((item) => {
    const path = String(item?.path || item?.url || '').toLowerCase();
    const title = String(item?.title || item?.displayName || item?.name || '').toLowerCase();
    return path.includes('/master/product-type') || title === 'product type' || title === 'product types';
  });
  if (!exists) {
    list.push({
      path: '/master/product-type',
      title: 'Product Type',
      name: 'Product Type',
      displayName: 'Product Type',
      icon: 'ft-arrow-right submenu-icon',
      class: '',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: []
    } as unknown as T);
  }
  return list;
}

export function sortMasterDataNavModules(modules: any[]): void {
  if (!modules?.length) {
    return;
  }

  modules.forEach((module) => {
    const name = (module?.moduleName || module?.displayName || '').toString();
    if (name === 'MasterData' || name === 'Master Data') {
      if (Array.isArray(module.submodules) && module.submodules.length > 1) {
        module.submodules.sort((a: any, b: any) => {
          const aTitle = (a.displayName || a.moduleName || '').trim();
          const bTitle = (b.displayName || b.moduleName || '').trim();
          return aTitle.localeCompare(bTitle, undefined, { sensitivity: 'base' });
        });
      }
    }

    if (Array.isArray(module.submodules)) {
      module.submodules.forEach((child: any) => sortMasterDataNavModules([child]));
    }
  });
}
